import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

// ─── CREATE ────────────────────────────────────────────────────────────────────

export const createReleaseNote = async (payload) => {
  try {
    const response = await authenticatedAxios.post(
      `${baseurl}release-notes/create/`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("createReleaseNote error:", error);
    return null;
  }
};

// ─── LIST ──────────────────────────────────────────────────────────────────────

export const fetchReleaseNotes = async () => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}release-notes/list/`
    );
    const result = response.data;
    if (Array.isArray(result)) return result;
    if (Array.isArray(result?.data)) return result.data;
    return [];
  } catch (error) {
    console.error("fetchReleaseNotes error:", error);
    return [];
  }
};

export const updateReleaseNote = async (id, payload) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}release-notes/update/${id}/`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("updateReleaseNote error:", error);
    return null;
  }
};

export const publishReleaseNote = async (id) => {
  try {
    const response = await authenticatedAxios.patch(
      `${baseurl}release-notes/update/${id}/`,
      { status: 'published' }
    );
    return response.data;
  } catch (error) {
    console.error("publishReleaseNote error:", error);
    return null;
  }
};